<template>
    <v-card>
        <v-card-text>
            <v-list-item three-line
                :prepend-avatar="'data:image/png;base64,'+((item||{}).imagem || '')"
                >
                <!-- <v-hover v-slot="{ hover }">
                    <v-list-item-prepend-avatar :size="hover ? 90: 90">
                    </v-list-item-prepend-avatar>
                </v-hover> -->
                <template v-slot:prepend>
                    <v-avatar
                        :size="120"
                        :src="'data:image/png;base64,'+((item||{}).imagem ||'')">
                    </v-avatar>
                </template>
                <v-list-item-title>
                    <div>
                        <v-chip label class="mr-1">{{item.ra}}</v-chip>
                        <v-chip label class="mr-1">{{item.sstatus}}</v-chip>
                        <v-chip label class="mr-1">{{item.turno}}</v-chip>
                        <h5 class="mt-1">{{item.nome}}</h5>
                    </div>
                </v-list-item-title>
                <v-list-item-subtitle>
                    <div>
                        <b>{{item.codcurso}} - {{item.habilitacao}} - {{item.codturma}} - {{item.codperlet}}</b>
                    </div>
                    <div v-if="item.respfin_nome">
                        <h5>
                            <helper-gdb text="Responsável Financeiro" icon="mdi-cash"/>
                            {{item.respfin_nome}}
                            <helper-gdb :text="item.respfin_email" icon="mdi-email"/>
                        </h5>
                    </div>
                    <div v-if="item.respacad_nome">
                        <h5>
                            <helper-gdb text="Responsável Acadêmico" icon="mdi-school" iconColor="primary"/>
                            {{item.respacad_nome}}
                            <helper-gdb :text="item.respacad_email" icon="mdi-email" iconColor="primary"/>
                        </h5>
                    </div>
                </v-list-item-subtitle>
            </v-list-item>
            <v-row>
                <v-col cols="12">
                    <v-btn class="mr-1"
                        v-show="!!item && !!item.ra" @click="onClose">
                        <v-icon>mdi-arrow-left</v-icon>
                        Voltar
                    </v-btn>
                </v-col>
            </v-row>
            <!-- LISTAS DO ALUNO -->
            <modal-gdb code="modal_lista_aluno"
                @on-toggle="onToggleListasAluno"
                dialog-width="100%" toolbar-title="Lista do Aluno"
                ref="modal_lista_aluno">
                <template v-slot:activate-slot>
                    <slot name="modal-activate">{{''}}</slot>
                </template>
                <template v-slot:body>
                    <card-item>
                        <template v-slot:text>
                            <ListaAluno :item="lista"
                                v-if="!!lista && !!lista.id"
                                @on-deleted="onDeleteListaAluno"
                                @on-refresh-prop-item="onRefreshPropItem"
                                />
                        </template>
                    </card-item>
                </template>
            </modal-gdb>

            <!-- VINCULAR NOVA LISTA ALUNO -->
            <modal-gdb code="modal_form_lista_aluno"
                dialog-width="100%" toolbar-title="Nova Lista do Aluno"
                @on-toggle="onToggleFormListaAluno"
                ref="modal_form_lista_aluno">
                <template v-slot:activate-slot>
                    <slot name="modal-activate">{{''}}</slot>
                </template>
                <template v-slot:body>
                    <card-item>
                        <template v-slot:text>
                            <AdicionarListaAluno :form="novoObjetoLista" @on-created="onCreatedListaAluno" :aluno="item"/>
                        </template>
                    </card-item>
                </template>
            </modal-gdb>

            <!-- VINCULAR NOVA ENTREGA LUPI -->
            <modal-gdb code="modal_form_entrega_lupi"
                dialog-width="100%" toolbar-title="Nova Entrega Lupi"
                @on-toggle="onToggleFormEntregaLupi"
                ref="modal_form_entrega_lupi">
                <template v-slot:activate-slot>
                    <slot name="modal-activate">{{''}}</slot>
                </template>
                <template v-slot:body>
                    <card-item>
                        <template v-slot:text>
                            <EntregaLupi :form="novoObjetoEntrega" @on-created="onCreatedEntregaLupi" :aluno="item"/>
                        </template>
                    </card-item>
                </template>
            </modal-gdb>

            <span v-if="$verify.has_perm('can_receber_material_checklistdb', false)">
                <!-- Botões de Listas vinculadas ao aluno -->
                <v-row>
                    <v-col cols="12" v-for="l, li in item.listas" :key="'lista_'+li">
                        <v-btn @click="selecionarListaAluno(l)"
                            :loading="$store.state.checklistdb.loading_id=='get-aluno-listas'"
                            block
                            :title="lista.lista_completa ? 'Lista Completa': 'Lista Incompleta'"
                            :color="lista.lista_completa ? 'success': 'primary'"
                            class="pa-8">
                            <template v-slot:default>
                                <div>
                                    <b>{{l.lista_object.codperlet}}</b> - {{l.lista_object.titulo}}
                                    <v-icon v-if="lista.lista_completa" color="success">mdi-check-circle</v-icon>
                                </div>
                            </template>
                        </v-btn>
                    </v-col>
                </v-row>
    
                <!-- Mensagem quando o aluno não estiver com Habilitacao ou Turma vinculada -->
                <v-row>
                    <v-col cols="12" v-show="(item.listas||[]).length == 0">
                        <v-alert class="text-warning text--lighten-3 text-center" color="warning" v-show="(!item.codturma || !item.codturma)">
                            <b> Aluno sem Habilitação ou Turma vinculada.</b>
                        </v-alert>
                        <v-btn @click="adicionarNovaLista"
                            title="Incluir uma nova lista para recebimento de materiais"
                            v-show="!(!item.codturma || !item.codturma)"
                            block
                            color="info"
                            class="pa-8">
                            <template v-slot:default>
                                <div>
                                    <v-icon size="large">mdi-plus</v-icon> &nbsp;
                                    <span v-if="$vuetify.display.mdAndUp">Nova lista para recebimento de materiais</span>
                                    <span v-else>Nova lista</span>
                                </div>
                            </template>
                        </v-btn>
                    </v-col>
                </v-row>
            </span>

            <span v-if="$verify.has_perm('can_entregar_material_checklistdb', false)">
                <!-- Botão para entrega de Material LUPI -->
                <v-row>
                    <v-col cols="12">
                        <v-btn @click="adicionarEntregaLupi"
                            title="Incluir entrega de material LUPI"
                            block
                            color="success"
                            class="pa-8">
                            <template v-slot:default>
                                <div>
                                    <b>Registrar Entregas LUPI</b>
                                </div>
                            </template>
                        </v-btn>
                    </v-col>
                </v-row>
            </span>


            <helper-gdb text="ItemAlunoSelecionado" v-if="$store.getters.StateAuthenticatedUser.is_superuser"/>
            <pre v-show="false">{{item}}</pre>
        </v-card-text>
    </v-card>
</template>
<script>
/* eslint-disable */
import { mapActions } from 'vuex'
import AdicionarListaAluno from './AdicionarListaAluno.vue'
import EntregaLupi from './entregalupi/EntregaLupi.vue'
import ListaAluno from './ListaAluno.vue'
export default {
    components: {
        ListaAluno, AdicionarListaAluno, EntregaLupi
    },
    props: {
        item: {
            required: true,
            default: {}
        },
        loading: {
            default: false
        }
    },
    data: ()=>({
        lista: {},
        novoObjetoLista: {},
        novoObjetoEntrega: {},
    }),
    mounted(){
    },
    methods: {
        ...mapActions(['GetCheckListAlunoLista','GetCheckListAlunoListas']),
        onCreatedListaAluno(value){
            if(value){
                this.closeModalListaAluno()
                this.atualizarListasDoAluno()
            }
        },
        onCreatedEntregaLupi(value){
            if(value){
                // provisoriamente não fechar, manter Modal aberta com a lista de registros do aluno
                // this.closeModalEntregaLupi()
            }
        },
        closeModalListaAluno(){
            this.$refs.modal_form_lista_aluno.dialog = false
        },
        closeModalEntregaLupi(){
            this.$refs.modal_form_entrega_lupi.dialog = false
        },
        onClose(){
            this.$emit('on-close', this.item)
        },
        async selecionarListaAluno(lista){
            /** Abre a Modal ao clicar na lista do aluno */
            this.$refs.modal_lista_aluno.dialog = true
            this.lista = await this.GetCheckListAlunoLista(lista.id)
        },
        adicionarNovaLista(){
            const {
                codpessoa, ra, nome, respfin_email, respfin_nome,
                respacad_email, respacad_nome, email } = this.item
            this.novoObjetoLista = Object.assign({}, {
                codpessoa, ra, nome, respfin_email, respfin_nome,
                respacad_email, respacad_nome, email,
                ...{ lista: null }
            })
            this.$refs.modal_form_lista_aluno.dialog = true
        },
        adicionarEntregaLupi(){
            const {
                ra, codperlet, codcurso, habilitacao, nome, turno, idperlet,
                codstatus, sstatus, codturma
                //, nome, email, respfin_email, respfin_nome, respacad_email, respacad_nome 
            } = this.item

            this.novoObjetoEntrega = Object.assign({}, {
                codigo_item_lupi: null,
                descricao_item_lupi: null,
                codperlet,
                ra,
                codcurso,
                habilitacao,
                nome,
                turno,
                idperlet,
                codstatus,
                sstatus,
                codturma,
                local_entrega: null,
                recebedor_tipo: null,
                recebedor_nome: this.item.respfin_nome,
                recebedor_email: this.item.respfin_email,
                quantidade_entregue: 1,
                quantidade_entregar: 1,
                obs: null,
                //ra, nome, respfin_email, respfin_nome,respacad_email, respacad_nome, email,
            })
            this.$refs.modal_form_entrega_lupi.dialog = true
        },
        async atualizarListasDoAluno(){
            const listas = await this.GetCheckListAlunoListas({
                                                                ra: this.item.ra,
                                                                codperlet: this.item.codperlet,
                                                                page_size: 15
                                                                })
            this.item.listas = listas
        },
        onDeleteListaAluno(){
            this.$refs.modal_lista_aluno.dialog = false
            this.atualizarListasDoAluno()
        },
        onRefreshPropItem(value){
            this.lista = value
        },
        onToggleListasAluno(value){
            if(value){
                // console.log('aberto onToggleListasAluno', value)
            }
        },
        onToggleFormListaAluno(value){
            if(value){
                // console.log('aberto onToggleFormListaAluno', value)
            }
        },
        onToggleFormEntregaLupi(value){
            if(value){
                // console.log('aberto onToggleFormEntregaLupi', value)
            }
        }
    },
    watch: {
        // propObject:{
        //     handler(value){
        //         const prop = value
        //         this.item = prop
        //         console.log('watch propObject', value, this.item)
        //     }, deep: true
        // }
    }
}
</script>
